export const ANNOTATION_WORKSPACE_ONLY_PERMISSION = 'annotation:workspace:only';

export const isAnnotationWorkspaceOnly = (user) =>
  Boolean(user?.permissions?.includes(ANNOTATION_WORKSPACE_ONLY_PERMISSION));
